import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "tickets",
  class: "mb-5"
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_3 = { class: "panel-title mb-0" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "card mb-3" }
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-3 mb-2" }
const _hoisted_14 = { class: "form-label" }
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "col-md-3 mb-2" }
const _hoisted_18 = { class: "form-label" }
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "col-md-3 mb-2" }
const _hoisted_25 = { class: "form-label" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = { class: "col-md-3 mb-2" }
const _hoisted_28 = { class: "form-label" }
const _hoisted_29 = { value: "" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-3 mb-2" }
const _hoisted_33 = { class: "form-label" }
const _hoisted_34 = ["value"]
const _hoisted_35 = ["value"]
const _hoisted_36 = ["value"]
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "col-md-3 mb-2" }
const _hoisted_39 = { class: "form-label" }
const _hoisted_40 = { class: "col-md-3 mb-2" }
const _hoisted_41 = { class: "form-label" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = {
  key: 0,
  class: "col-md-3 mb-2"
}
const _hoisted_44 = { class: "form-label" }
const _hoisted_45 = { value: false }
const _hoisted_46 = { value: true }
const _hoisted_47 = { class: "col-md-3 mb-2" }
const _hoisted_48 = { class: "form-label" }
const _hoisted_49 = { class: "col-md-3 mb-2 d-flex align-items-end" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "d-flex justify-content-between align-items-center text-muted small mb-2" }
const _hoisted_52 = { class: "table-responsive" }
const _hoisted_53 = { class: "table table-dark table-striped mb-0" }
const _hoisted_54 = { class: "badge bg-secondary" }
const _hoisted_55 = ["title"]
const _hoisted_56 = ["title"]
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_60 = { class: "badge bg-secondary" }
const _hoisted_61 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_62 = { class: "pagination justify-content-center" }
const _hoisted_63 = ["onClick"]

import { ref, computed, onMounted, watch, getCurrentInstance } from 'vue'
import { formatIsoDate } from "@/utils/format"
import { getFeatureFlags } from "@/services/featureFlags"
import { Ticket, TicketType, isEnhancedReport } from "shared/Ticket"
import { reportStatusBadgeClass, reportStatusLabelKey, ticketStatusBadgeClass } from "@/services/reportStatusPresenter"
import { TicketStatusFilter, TicketSort, TicketQuery, GroupFilter, AssignedFilter } from "shared/TicketQuery"
import { User } from "shared/User"
import { PaginatedResult, emptyPaginatedResult } from "shared/PaginatedResult"
import { apiPost } from "@/services/api/client";
import StateBlock from "@/components/ui/StateBlock.vue";
import PanelNoAccess from "@/components/panel/PanelNoAccess.vue";
import { panelRequest, isForbidden, reportPanelError } from "@/components/panel/panelAccess";

interface Props {
  user: User
  groupsMap: Record<string, any>
  lang: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TicketsTableComponent',
  props: {
    user: {},
    groupsMap: {},
    lang: {}
  },
  setup(__props: any) {

const instance = getCurrentInstance()
const t = (key: string, named?: Record<string, unknown>): string => (instance!.proxy as any).$t(key, named ?? {})

// Props
const props = __props

// Reactive data
const tickets = ref<Ticket[]>([])
const loadingTickets = ref(false)
const forbidden = ref(false)
const totalTickets = ref(0)
const currentPage = ref(1)
const itemsPerPage = ref(25)

// Filters
const selectedType = ref<TicketType>(TicketType.SUPPORT)
const statusFilter = ref<TicketStatusFilter>(TicketStatusFilter.OPENED)
const juryReportsEnabled = ref(false)
const searchFilter = ref('')
const selectedGroup = ref('')
const sortBy = ref<TicketSort>(TicketSort.NEWEST)
const showWeb = ref(false)
const createdFrom = ref<string>('')
const createdTo = ref<string>('')

// Computed properties
const availableGroups = computed(() => {
  const groups = props.groupsMap[selectedType.value] || {}
  return Object.keys(groups)
})

const paginatedTickets = computed(() => {
  return tickets.value
})

const totalPages = computed(() => {
  const total = Number(totalTickets.value) || 0;
  const perPage = Number(itemsPerPage.value) || 1;
  return Math.max(1, Math.ceil(total / perPage));
})

const visiblePages = computed(() => {
  const pages = []
  const maxVisible = 5
  let start = Math.max(1, currentPage.value - Math.floor(maxVisible / 2))
  let end = Math.min(totalPages.value, start + maxVisible - 1)

  if (end - start + 1 < maxVisible) {
    start = Math.max(1, end - maxVisible + 1)
  }

  for (let i = start; i <= end; i++) {
    pages.push(i)
  }

  return pages
})

// Methods
const getTypeBadgeClass = (type: TicketType) => {
  return type === TicketType.SUPPORT ? 'badge bg-primary' : 'badge bg-danger'
}

const buildQuery = (): TicketQuery & { createdFrom?: number, createdTo?: number } => {
  const groupFilter: GroupFilter = selectedGroup.value
    ? { selectAll: false, groups: [selectedGroup.value] }
    : { selectAll: true, groups: [] }

  const assignedFilter: AssignedFilter = { selectAll: true, assigned: [] }

  let createdFromTimestamp: number | undefined = undefined
  let createdToTimestamp: number | undefined = undefined
  if (createdFrom.value) {
    createdFromTimestamp = new Date(createdFrom.value + 'T00:00:00Z').getTime()
  }
  if (createdTo.value) {
    createdToTimestamp = new Date(createdTo.value + 'T23:59:59Z').getTime()
  }

  return {
    type: selectedType.value,
    searchFilter: searchFilter.value,
    statusFilter: statusFilter.value,
    sort: sortBy.value,
    groupFilter,
    assignedFilter,
    isWeb: showWeb.value,
    cursor: null,
    ...(createdFromTimestamp ? { createdFrom: createdFromTimestamp } : {}),
    ...(createdToTimestamp ? { createdTo: createdToTimestamp } : {})
  }
}

const fetchTickets = async () => {
  loadingTickets.value = true;
  try {
    const endpoint = selectedType.value === TicketType.SUPPORT ? "/tickets/paginated" : "/reports/paginated";
    const query = buildQuery();
    const page = currentPage.value;
    const pageSize = itemsPerPage.value;
    const response = await apiPost(endpoint, { ...query, page, pageSize }, panelRequest) as { data: Ticket[], total: number }
    tickets.value = response.data;
    totalTickets.value = Number(response.total) || 0;
  } catch (error) {
    if (isForbidden(error)) forbidden.value = true;
    else reportPanelError('Error fetching tickets:', error);
    tickets.value = [];
    totalTickets.value = 0;
  } finally {
    loadingTickets.value = false;
  }
};

const applyFilters = async () => {
  currentPage.value = 1
  await fetchTickets()
}

const refreshTickets = async () => {
  await fetchTickets()
}

const goToPage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page
    fetchTickets()
  }
}

const downloadCSV = async () => {
  try {
    const query = buildQuery()
    const endpoint = selectedType.value === TicketType.SUPPORT ? "/tickets/csv" : "/reports/csv"

    const blob = await apiPost(endpoint, query, {
      responseType: 'blob',
      skipSwal: true
    }) as unknown as Blob;
    const text = await blob.text();
    const downloadBlob = new Blob([text], { type: 'text/csv' });
    const url = window.URL.createObjectURL(downloadBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `tickets_${selectedType.value === TicketType.SUPPORT ? 'support' : 'reports'}_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

  } catch (error) {
    console.error('Error downloading CSV:', error)
    alert(t('panel.tickets.csvFailed'))
  }
}

const downloadJSON = async () => {
  try {
    const query = buildQuery()
    const endpoint = selectedType.value === TicketType.SUPPORT ? "/tickets/json" : "/reports/json"
    const blob = await apiPost(endpoint, query, {
      responseType: 'blob',
      skipSwal: true
    }) as unknown as Blob;
    const text = await blob.text();
    const downloadBlob = new Blob([text], { type: 'application/json' });
    const url = window.URL.createObjectURL(downloadBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `tickets_${selectedType.value === TicketType.SUPPORT ? 'support' : 'reports'}_${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    console.error('Error downloading JSON:', error)
    alert(t('panel.tickets.jsonFailed'))
  }
}

// Lifecycle
onMounted(async () => {
  const flags = await getFeatureFlags()
  juryReportsEnabled.value = flags.juryReports
  if (!flags.juryReports && statusFilter.value === TicketStatusFilter.JURY) {
    statusFilter.value = TicketStatusFilter.OPENED
  }
  fetchTickets()
})

// Watchers
watch(selectedType, () => {
  selectedGroup.value = ''
  applyFilters()
})

watch([selectedType, itemsPerPage], () => {
  selectedGroup.value = ''
  applyFilters()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('panel.tickets.title')), 1),
      (!forbidden.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn btn-primary me-2",
              onClick: downloadCSV,
              disabled: loadingTickets.value
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-download me-1" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.tickets.downloadCsv')), 1)
            ], 8, _hoisted_5),
            _createElementVNode("button", {
              class: "btn btn-outline-secondary me-2",
              onClick: downloadJSON,
              disabled: loadingTickets.value
            }, [
              _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-download me-1" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.tickets.downloadJson')), 1)
            ], 8, _hoisted_6),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: refreshTickets,
              disabled: loadingTickets.value
            }, [
              _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.tickets.refresh')), 1)
            ], 8, _hoisted_7)
          ]))
        : _createCommentVNode("", true)
    ]),
    (forbidden.value)
      ? (_openBlock(), _createBlock(PanelNoAccess, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h5", _hoisted_10, _toDisplayString(_ctx.$t('panel.tickets.filters')), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('panel.tickets.ticketType')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedType).value = $event)),
                    class: "form-select",
                    onChange: applyFilters
                  }, [
                    _createElementVNode("option", {
                      value: _unref(TicketType).SUPPORT
                    }, _toDisplayString(_ctx.$t('panel.tickets.support')), 9, _hoisted_15),
                    _createElementVNode("option", {
                      value: _unref(TicketType).REPORT
                    }, _toDisplayString(_ctx.$t('panel.tickets.reports')), 9, _hoisted_16)
                  ], 544), [
                    [_vModelSelect, selectedType.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('panel.tickets.status')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((statusFilter).value = $event)),
                    class: "form-select",
                    onChange: applyFilters
                  }, [
                    _createElementVNode("option", {
                      value: _unref(TicketStatusFilter).OPENED
                    }, _toDisplayString(_ctx.$t('panel.tickets.open')), 9, _hoisted_19),
                    _createElementVNode("option", {
                      value: _unref(TicketStatusFilter).CLOSED
                    }, _toDisplayString(_ctx.$t('panel.tickets.closed')), 9, _hoisted_20),
                    (__props.user.power >= 2)
                      ? (_openBlock(), _createElementBlock("option", {
                          key: 0,
                          value: _unref(TicketStatusFilter).MINE
                        }, _toDisplayString(_ctx.$t('panel.tickets.mine')), 9, _hoisted_21))
                      : _createCommentVNode("", true),
                    (__props.user.power >= 2)
                      ? (_openBlock(), _createElementBlock("option", {
                          key: 1,
                          value: _unref(TicketStatusFilter).UNASSIGNED
                        }, _toDisplayString(_ctx.$t('panel.tickets.unassigned')), 9, _hoisted_22))
                      : _createCommentVNode("", true),
                    (juryReportsEnabled.value)
                      ? (_openBlock(), _createElementBlock("option", {
                          key: 2,
                          value: _unref(TicketStatusFilter).JURY
                        }, _toDisplayString(_ctx.$t('panel.tickets.juryDuty')), 9, _hoisted_23))
                      : _createCommentVNode("", true)
                  ], 544), [
                    [_vModelSelect, statusFilter.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('panel.tickets.search')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchFilter).value = $event)),
                    type: "text",
                    class: "form-control",
                    placeholder: _ctx.$t('panel.tickets.searchPlaceholder'),
                    onKeyup: _withKeys(applyFilters, ["enter"])
                  }, null, 40, _hoisted_26), [
                    [_vModelText, searchFilter.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('panel.tickets.group')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedGroup).value = $event)),
                    class: "form-select",
                    onChange: applyFilters
                  }, [
                    _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.$t('panel.tickets.allGroups')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableGroups.value, (group) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: group,
                        value: group
                      }, _toDisplayString(group), 9, _hoisted_30))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, selectedGroup.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('panel.tickets.sortBy')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sortBy).value = $event)),
                    class: "form-select",
                    onChange: applyFilters
                  }, [
                    _createElementVNode("option", {
                      value: _unref(TicketSort).NEWEST
                    }, _toDisplayString(_ctx.$t('panel.tickets.newest')), 9, _hoisted_34),
                    _createElementVNode("option", {
                      value: _unref(TicketSort).OLDEST
                    }, _toDisplayString(_ctx.$t('panel.tickets.oldest')), 9, _hoisted_35),
                    _createElementVNode("option", {
                      value: _unref(TicketSort).LATEST_COMMENT
                    }, _toDisplayString(_ctx.$t('panel.tickets.latestComment')), 9, _hoisted_36),
                    _createElementVNode("option", {
                      value: _unref(TicketSort).OLDEST_COMMENT
                    }, _toDisplayString(_ctx.$t('panel.tickets.oldestComment')), 9, _hoisted_37)
                  ], 544), [
                    [_vModelSelect, sortBy.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('panel.tickets.createdFrom')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((createdFrom).value = $event)),
                    class: "form-control",
                    onChange: applyFilters
                  }, null, 544), [
                    [_vModelText, createdFrom.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('panel.tickets.createdTo')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((createdTo).value = $event)),
                    class: "form-control",
                    onChange: applyFilters
                  }, null, 544), [
                    [_vModelText, createdTo.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                (__props.user.power >= 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('panel.tickets.source')), 1),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showWeb).value = $event)),
                        class: "form-select",
                        onChange: applyFilters
                      }, [
                        _createElementVNode("option", _hoisted_45, _toDisplayString(_ctx.$t('panel.tickets.inGame')), 1),
                        _createElementVNode("option", _hoisted_46, _toDisplayString(_ctx.$t('panel.tickets.web')), 1)
                      ], 544), [
                        [_vModelSelect, showWeb.value]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('panel.tickets.itemsPerPage')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((itemsPerPage).value = $event)),
                    class: "form-select",
                    onChange: applyFilters
                  }, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("option", { value: 25 }, "25", -1),
                    _createElementVNode("option", { value: 50 }, "50", -1),
                    _createElementVNode("option", { value: 100 }, "100", -1),
                    _createElementVNode("option", { value: 200 }, "200", -1)
                  ]))], 544), [
                    [_vModelSelect, itemsPerPage.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("button", {
                    class: "btn btn-primary w-100",
                    onClick: applyFilters,
                    disabled: loadingTickets.value
                  }, [
                    _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fa fa-filter me-1" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('panel.tickets.applyFilters')), 1)
                  ], 8, _hoisted_50)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('panel.tickets.showing', { shown: paginatedTickets.value ? paginatedTickets.value.length : 0, total: totalTickets.value })), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('panel.tickets.page', { page: currentPage.value, pages: totalPages.value })), 1)
          ]),
          _createVNode(StateBlock, {
            loading: loadingTickets.value,
            "loading-text": _ctx.$t('panel.tickets.loading')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("table", _hoisted_53, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[16] || (_cache[16] = _createElementVNode("th", null, "ID", -1)),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tickets.colTitle')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tickets.colType')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tickets.group')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tickets.colCategory')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tickets.status')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tickets.colCreatedBy')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tickets.colAssignedTo')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tickets.colComments')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tickets.colCreated')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('panel.tickets.colLastComment')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedTickets.value || [], (ticket) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: ticket._id
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_54, _toDisplayString(ticket._id), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", {
                            class: "text-truncate",
                            style: {"max-width":"200px"},
                            title: ticket.title
                          }, _toDisplayString(ticket.title), 9, _hoisted_55)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(getTypeBadgeClass(ticket.type))
                          }, _toDisplayString(ticket.type === _unref(TicketType).SUPPORT ? _ctx.$t('panel.tickets.support') : _ctx.$t('panel.tickets.typeReport')), 3)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(ticket.group), 1),
                        _createElementVNode("td", null, _toDisplayString(ticket.category), 1),
                        _createElementVNode("td", null, [
                          (_unref(isEnhancedReport)(ticket))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["badge", _unref(reportStatusBadgeClass)(ticket)])
                              }, _toDisplayString(_ctx.$t(_unref(reportStatusLabelKey)(ticket))), 3))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: _normalizeClass(_unref(ticketStatusBadgeClass)(ticket.status))
                              }, _toDisplayString(ticket.status), 3))
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", {
                            class: "text-truncate",
                            style: {"max-width":"120px"},
                            title: ticket.createdBy.name
                          }, _toDisplayString(ticket.createdBy.name), 9, _hoisted_56)
                        ]),
                        _createElementVNode("td", null, [
                          (ticket.assignees.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticket.assignees, (assignee) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: assignee._id,
                                    class: "badge bg-info me-1"
                                  }, _toDisplayString(assignee.name), 1))
                                }), 128))
                              ]))
                            : (ticket.roleAssignees.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticket.roleAssignees, (role) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: role,
                                      class: "badge bg-warning me-1"
                                    }, _toDisplayString(role), 1))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.$t('panel.tickets.unassigned')), 1))
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_60, _toDisplayString(ticket.commentsCount), 1)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_unref(formatIsoDate)(ticket.timestamp)), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(formatIsoDate)(ticket.lastComment)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["loading", "loading-text"]),
          (totalPages.value > 1)
            ? (_openBlock(), _createElementBlock("nav", _hoisted_61, [
                _createElementVNode("ul", _hoisted_62, [
                  _createElementVNode("li", {
                    class: _normalizeClass(["page-item", { disabled: currentPage.value === 1 }])
                  }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#",
                      onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (goToPage(currentPage.value - 1)), ["prevent"]))
                    }, [...(_cache[17] || (_cache[17] = [
                      _createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1)
                    ]))])
                  ], 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: page,
                      class: _normalizeClass(["page-item", { active: page === currentPage.value }])
                    }, [
                      _createElementVNode("a", {
                        class: "page-link",
                        href: "#",
                        onClick: _withModifiers(($event: any) => (goToPage(page)), ["prevent"])
                      }, _toDisplayString(page), 9, _hoisted_63)
                    ], 2))
                  }), 128)),
                  _createElementVNode("li", {
                    class: _normalizeClass(["page-item", { disabled: currentPage.value === totalPages.value }])
                  }, [
                    _createElementVNode("a", {
                      class: "page-link",
                      href: "#",
                      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (goToPage(currentPage.value + 1)), ["prevent"]))
                    }, [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1)
                    ]))])
                  ], 2)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})